import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useListContext, useNotify, useRecordContext, useRefresh } from "react-admin";
import { useRef, useState } from "react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { DeliveryNoteDocumentType } from "src/@generated/schemas";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import cookie from "js-cookie";
import i18next from "src/locales";
import { url } from "src";
import { useUploadDeliveryNoteDocumentMutation } from "src/@generated/hooks";

export const DeliveryNoteDocuments = ({ row }) => {
  const record = useRecordContext();
  const { refetch } = useListContext();
  const [upload, { loading }] = useUploadDeliveryNoteDocumentMutation();

  const MAX_FILE_SIZE = 20 * 1024 * 1024;

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
  const [type, setType] = useState<string>("");
  const notify = useNotify();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFiles([]);
    setType("");
    if (inputRef.current) inputRef.current.value = "";
  };

  const handleFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = Array.from(e.target.files || []);

    const invalid = selected.find(f => f.size > MAX_FILE_SIZE);
    if (invalid) {
      alert(i18next.translate('resources.DeliveryNote.errors.tooBigFile', {name: invalid.name}));
      e.target.value = "";
      return;
    }

    setFiles(selected);
  };

  const handleUpload = async () => {
    try {
      for (const file of files) {
        await upload({
          variables: {
            file,
            type, // ← tady si to napojíš na enum / hodnotu
            deliveryNoteId: record.id as string,
          },
        });
      }

      notify(i18next.translate('resources.DeliveryNote.fields.success_upload'), { type: 'success' });

      refetch();
      handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      {/* PLUS */}
      <IconButton size="small" onClick={handleOpen}>
        <AddCircleOutlineIcon />
      </IconButton>

      {/* DIALOG */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{i18next.translate('resources.DeliveryNote.fields.upload_documents')}</DialogTitle>

        <DialogContent>
          {/* TYP DOKUMENTU */}
          <FormControl fullWidth margin="normal">
            <InputLabel>{i18next.translate('resources.DeliveryNote.fields.document_type')}</InputLabel>
            <Select
              value={type}
              label={i18next.translate('resources.DeliveryNote.fields.document_type')}
              onChange={(e) => setType(e.target.value)}
            >
              <MenuItem value={DeliveryNoteDocumentType.Complaint}>{i18next.translate('resources.DeliveryNote.fields.document_type_complaint')}</MenuItem>
              <MenuItem value={DeliveryNoteDocumentType.Order}>{i18next.translate('resources.DeliveryNote.fields.document_type_order')}</MenuItem>
              <MenuItem value={DeliveryNoteDocumentType.Photo}>{i18next.translate('resources.DeliveryNote.fields.document_type_photo')}</MenuItem>
            </Select>
          </FormControl>

          <br />
          <br />

          {/* FILE INPUT */}
          <Button
            variant="outlined"
            onClick={() => inputRef.current?.click()}
            disabled={loading}
          >
            {i18next.translate('resources.Global.selectFile')}
          </Button>

          <input
            ref={inputRef}
            type="file"
            multiple
            onChange={handleFilesChange}
            style={{ display: "none" }}
          />

          {/* VYBRANÉ SOUBORY */}
          {files.length > 0 && (
            <ul style={{ marginTop: 12 }}>
              {files.map((file) => (
                <li key={file.name}>
                  {file.name} ({Math.round(file.size / 1024)} KB)
                </li>
              ))}
            </ul>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>{i18next.translate('resources.Global.cancel')}</Button>
          <Button
            variant="contained"
            onClick={handleUpload}
            disabled={!files.length || !type || loading}
          >
            {i18next.translate('resources.Global.upload')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* EXISTUJÍCÍ DOKUMENTY */}
      {row.documents?.map((document, key) => (
        <div key={document.id}>
          <a
            href={`${url}/delivery-note/${document.id}/download-document?access_token=${cookie.get(
              "access_token"
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ whiteSpace: "nowrap" }}
          >
            #{key + 1} {document?.type}{" "}
            <FileCopyIcon style={{ fontSize: 11 }} />
          </a>
        </div>
      ))}
    </div>
  );
};
